var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Headline } from '../Headline';
import { Card } from '../Card';
import { Icon } from '../Icon';
export const FlowCardStep = (_a) => {
    var { orderNumber, headerIcon, title, headerAction, content, footerAction, error, saved, active, className, disabled, style } = _a, rest = __rest(_a, ["orderNumber", "headerIcon", "title", "headerAction", "content", "footerAction", "error", "saved", "active", "className", "disabled", "style"]);
    const statusIcon = classnames('FlowCardStep__status', {
        'FlowCardStep__status--error': error && !headerIcon,
        'FlowCardStep__status--active': active && !disabled && !headerIcon,
        'FlowCardStep__status--saved': !active && saved && !headerIcon,
    });
    const cardState = classnames('FlowCardStep', className, {
        'FlowCardStep--error': error,
        'FlowCardStep--active': active && !disabled,
        'FlowCardStep--saved': !active && saved,
        'FlowCardStep--ordered': orderNumber !== undefined,
        'FlowCardStep--headerOnly': !content,
    });
    const FlowCardStepStatus = () => {
        if (error) {
            return (React.createElement(Icon, { name: "warning", size: "18px", className: "FlowCardStep__indicator-error" }));
        }
        if (orderNumber !== undefined && orderNumber !== false) {
            if (saved && !active) {
                return (React.createElement(Icon, { name: "check_circle", size: "24px", className: "FlowCardStep__indicator-active" }));
            }
            return orderNumber;
        }
        if (active && !disabled)
            return (React.createElement(Icon, { name: "edit", size: "14px", className: "FlowCardStep__icon-active" }));
        if (saved) {
            return (React.createElement(Icon, { name: "check_circle", size: "24px", className: "FlowCardStep__indicator-complete" }));
        }
        return (React.createElement(Icon, { name: "check_circle", size: "24px", className: "FlowCardStep__indicator-disabled" }));
    };
    return (React.createElement(Card, Object.assign({}, rest, { className: cardState, disabled: disabled, style: style, "data-anvil-component": "FlowCardStep", "aria-current": active && 'step' }),
        React.createElement(Card.Section, { className: "FlowCardStep__header" },
            React.createElement("div", { className: "d-f align-items-center" },
                React.createElement("span", { className: "FlowCardStep__statusWrapper" }, headerIcon ? (headerIcon) : (React.createElement("span", { className: statusIcon }, FlowCardStepStatus()))),
                React.createElement(Headline, { className: "m-b-0 d-f align-items-end" }, title)),
            headerAction && headerAction),
        content && React.createElement(Card.Section, null, content),
        footerAction && (React.createElement(Card.Section, { className: "FlowCardStep__footer" }, footerAction))));
};
//# sourceMappingURL=FlowCardStep.js.map